module.exports = __webpack_public_path__ + "static/img/PN.f6daae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PN.png
// module id = ONMJ
// module chunks = 34